import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { CanActivate } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class CashNowGuard implements CanActivate {

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    return !(
      state.url.includes("caja-ya") &&
      sessionStorage.getItem('cajaYa') === "false"
    );
  }
}
